// This is where you apply for a goodleap loan & submit the application...
import React, { useState, useEffect, useReducer } from "react";
import axios from "axios";
import CircularProgress from "@material-ui/core/CircularProgress";
import moment from "moment";
import NumberFormat from "react-number-format";
import Button from "@material-ui/core/Button";

import GoodLeapLogo from "../../../assets/images/goodleap-logo.svg";
import ssl from "../../../assets/images/ssl.svg";
import encryption from "../../../assets/images/encryption.svg";
import checkmark from "../../../assets/images/checkmark.svg";
import CheckboxForm from "../../Dashboard/CheckboxForm";
import GoodLeapApi from "../api/goodleap-api";

const GoodLeapQualify = ({
  name,
  customer,
  email,
  phone,
  street,
  city,
  state,
  zip,
  setGoodLeap,
  viewApps,
  setViewApps,
  financingAmount,
  loanA,
  loanAmount,
  goodLeapApplications,
}) => {
  let names = name.split(" ");

  const [stateA, setStateA] = useState("");
  const [secondaryIncome, setSecondaryIncome] = useState("");
  const [social, setSocial] = useState("");
  const [birthMonth, setBirthMonth] = useState("");
  const [birthDay, setBirthDay] = useState("");
  const [birthYear, setBirthYear] = useState("");
  const [coBirthMonth, setCoBirthMonth] = useState("");
  const [coBirthDay, setCoBirthDay] = useState("");
  const [coBirthYear, setCoBirthYear] = useState("");
  const [confirmedApp, setConfirmedApp] = useState(false);
  const [creditResult, setCreditResult] = useState("Pending");
  const [creditMessage, setCreditMessage] = useState([]);
  const [coApp, setCoApp] = useState("");
  const [otherInc, setOtherInc] = useState("");
  const [pad, setPad] = useState("");
  const [loading, setLoading] = useState(false);
  const [loanId, setLoanId] = useState("");
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [confirmEmail, setConfirmEmail] = useState(false);
  const [coApply, setCoApply] = useState(false);
  const [disclosures, setDisclosures] = useState([]);
  const [disclosureToken, setDisclosureToken] = useState("");
  const [allChecked, setAllChecked] = useState(false);
  const repFirstName = customer?.salesRep?.split(" ")[0];
  const repLastName = customer?.salesRep?.split(" ")[1];
  const initialState = {
    // method: "submit_loan_application",
    firstName: "",
    lastName: "",
    dob: "",
    ssn: "",
    annualIncome_value: null,
    email: "",
    primaryPhoneNumber_value: "",
    primaryPhoneNumber_type: "HOME",
    coapplicant_firstName: "",
    coapplicant_lastName: "",
    coapplicant_dob: "",
    coapplicant_ssn: "",
    coapplicant_annualIncome_value: null,
    coapplicant_email: "",
    coapplicant_primaryPhoneNumber_value: "",
    coapplicant_primaryPhoneNumber_type: "HOME",
    coapplicant_electronicConsent: true,
    coapplicant_homeOccupancy: "PRIMARY",
    coapplicant_homeOwnership: "OWNED_WITH_MORTGAGE",
    coapplicant_employmentStatus: "EMPLOYED",
    coapplicant_citizenshipStatus: "US_CITIZEN",
    coapplicant_spokenLanguage: "ENGLISH",
    electronicConsent: true,
    homeOccupancy: "PRIMARY",
    homeOwnership: "OWNED_WITH_MORTGAGE",
    street: "",
    street2: null,
    city: "",
    state: "",
    zip: "",
    employmentStatus: "EMPLOYED",
    citizenshipStatus: "US_CITIZEN",
    spokenLanguage: "ENGLISH",
    submittingUser_firstName: repFirstName,
    submittingUser_lastName: repLastName,
    submittingUser_email: customer?.repEmail,
    offerId: loanA.offerId ? loanA.offerId : "",
    amount_value: 5432.1,
    applicantSignature: "",
    subjectProperty_street: "",
    subjectProperty_street2: "",
    subjectProperty_city: "",
    subjectProperty_state: "",
    subjectProperty_zip: "",
    disclosureToken: "",
  };

  function reducer(state, action) {
    switch (action.type) {
      case "setField":
        return { ...state, [action.field]: action.value };
      default:
        throw new Error("Unhandled action type");
    }
  }

  // set up disclosures, disclosure token and offerId
  useEffect(() => {
    const getDisclosures = async () => {
      const res = await GoodLeapApi.getDisclosures();
      setDisclosures(res.data.data[0].sections);
      setDisclosureToken(res.data.data[0].token);
      handleInputChange("disclosureToken", res.data.data[0].token);
    };

    const getOfferId = async () => {
      const res = await GoodLeapApi.getOffers();
      const selectedOffer = res.data.data.find(
        (offer) =>
          offer.term === loanA.loanTerm && offer.rate === loanA.loanInterest
      );
      handleInputChange("offerId", selectedOffer?.id);
    };

    getOfferId();
    getDisclosures();
  }, []);

  const [formState, dispatch] = useReducer(reducer, initialState);

  const handleInputChange = (field, value) => {
    dispatch({ type: "setField", field: field, value: value });
  };

  const listOfStates = require("us-state-converter");

  const fiftyStates = listOfStates.only50();

  //development url for goodleap
  const apiUrl = `https://dev.iondeveloper.com/api/proposal/goodleap/?api_key=${process.env.REACT_APP_API_KEY}`;

  useEffect(() => {
    const valuesToSet = [
      { key: "firstName", value: names[0] },
      { key: "lastName", value: names[1] },
      { key: "email", value: email },
      { key: "primaryPhoneNumber_value", value: phone },
      { key: "street", value: street },
      { key: "city", value: city },
      { key: "state", value: listOfStates.abbr(state) },
      { key: "zip", value: zip },
      { key: "disclosureToken", value: disclosureToken },
      { key: "amount_value", value: loanAmount },
    ];

    !viewApps &&
      valuesToSet.forEach((item) => {
        handleInputChange(item.key, item.value);
      });
  }, [
    name,
    email,
    phone,
    street,
    city,
    state,
    zip,
    disclosureToken,
    financingAmount,
    viewApps,
  ]);

  let fullBirthDate;
  let coFullBirthDate;

  useEffect(() => {
    coFullBirthDate = moment(
      `${coBirthYear}-${coBirthMonth}-${coBirthDay}`
    ).format("YYYY-MM-DD");
    handleInputChange("coapplicant_dob", coFullBirthDate);
  }, [coBirthYear, coBirthMonth, coBirthDay]);

  useEffect(() => {
    fullBirthDate = moment(`${birthYear}-${birthMonth}-${birthDay}`).format(
      "YYYY-MM-DD"
    );
    handleInputChange("dob", fullBirthDate);
  }, [birthYear, birthMonth, birthDay]);

  useEffect(() => {
    if (birthDay.length === 1) {
      setBirthDay("0" + birthDay);
    }
  }, [birthDay]);

  useEffect(() => {
    if (coBirthDay.length === 1) {
      setCoBirthDay("0" + coBirthDay);
    }
  }, [coBirthDay]);

  if (secondaryIncome.toString().length < 1) {
    setSecondaryIncome("0");
  }

  const daysInMonth = new Date(+birthYear, birthMonth, 0).getDate();
  const coDaysInMonth = new Date(+coBirthYear, coBirthMonth, 0).getDate();

  const days = [];
  const coDays = [];
  const years = [];

  const findDays = (arr, num) => {
    for (var i = 1; i < num + 1; i++) {
      arr.push(i);
    }
  };

  const findYears = (arr) => {
    for (var i = 1930; i < new Date().getFullYear() - 17; i++) {
      arr.push(i);
    }
  };

  findDays(days, daysInMonth);
  findDays(coDays, coDaysInMonth);
  findYears(years);

  let mappedStates = fiftyStates.map((state, i) => {
    return (
      <option key={i} value={state.usps}>
        {state.usps}
      </option>
    );
  });

  let months = [
    { month: "January", val: "01" },
    { month: "February", val: "02" },
    { month: "March", val: "03" },
    { month: "April", val: "04" },
    { month: "May", val: "05" },
    { month: "June", val: "06" },
    { month: "July", val: "07" },
    { month: "August", val: "08" },
    { month: "September", val: "09" },
    { month: "October", val: "10" },
    { month: "November", val: "11" },
    { month: "December", val: "12" },
  ];

  let mappedMonths = months.map((month, i) => {
    return (
      <option key={i} value={month.val}>
        {month.month}
      </option>
    );
  });

  const mappedDays = days.map((num, i) => {
    return (
      <option key={i} value={num}>
        {num}
      </option>
    );
  });

  const mappedCoDays = coDays.map((num, i) => {
    return (
      <option key={i} value={num}>
        {num}
      </option>
    );
  });

  const mappedYears = years.reverse().map((num, i) => {
    return (
      <option key={i} value={num}>
        {num}
      </option>
    );
  });

  useEffect(() => {
    setSocial(social.replace(/\D/g, ""));
  }, [social]);

  const createApplication = () => {
    if (formState.ssn.length !== 4) {
      return (
        setShowError(true),
        setErrorMessage(`Please add customer's social`),
        setTimeout(function () {
          setShowError(false);
          setErrorMessage(``);
        }, 10000)
      );
    }
    if (formState.annualIncome_value === "") {
      return (
        setShowError(true),
        setErrorMessage(`Please add customer's annual income`),
        setTimeout(function () {
          setShowError(false);
          setErrorMessage(``);
        }, 10000)
      );
    }
    if (
      birthDay === "" ||
      birthMonth === "" ||
      birthYear === "" ||
      fullBirthDate === "Invalid date"
    ) {
      return (
        setShowError(true),
        setErrorMessage(`Please add customer's date of birth info`),
        setTimeout(function () {
          setShowError(false);
          setErrorMessage(``);
        }, 10000)
      );
    }
    if (coApply) {
      if (
        coBirthDay === "" ||
        coBirthMonth === "" ||
        coBirthYear === "" ||
        coFullBirthDate === "Invalid date"
      ) {
        return (
          setShowError(true),
          setErrorMessage(`Please add co-applicant's date of birth info`),
          setTimeout(function () {
            setShowError(false);
            setErrorMessage(``);
          }, 10000)
        );
      }
      if (formState.coapplicant_annualIncome_value === "") {
        return (
          setShowError(true),
          setErrorMessage(`Please add co-applicant's annual income`),
          setTimeout(function () {
            setShowError(false);
            setErrorMessage(``);
          }, 10000)
        );
      }
      if (formState.coapplicant_ssn.length !== 4) {
        return (
          setShowError(true),
          setErrorMessage(`Please add co-applicant's social`),
          setTimeout(function () {
            setShowError(false);
            setErrorMessage(``);
          }, 10000)
        );
      }
      if (
        formState.coapplicant_firstName === "" ||
        formState.coapplicant_lastName === ""
      ) {
        return (
          setShowError(true),
          setErrorMessage(`Please add co-applicant's name`),
          setTimeout(function () {
            setShowError(false);
            setErrorMessage(``);
          }, 10000)
        );
      }
      if (formState.coapplicant_primaryPhoneNumber_value === "") {
        return (
          setShowError(true),
          setErrorMessage(`Please add co-applicant's phone number`),
          setTimeout(function () {
            setShowError(false);
            setErrorMessage(``);
          }, 10000)
        );
      }
      if (formState.coapplicant_email === "") {
        return (
          setShowError(true),
          setErrorMessage(`Please add co-applicant's email`),
          setTimeout(function () {
            setShowError(false);
            setErrorMessage(``);
          }, 10000)
        );
      }
    }
    submitApplication();
    setLoading(true);
  };
  const submitApplication = async () => {
    try {
      const res = await GoodLeapApi.submitLoanApplication({
        formState: formState,
      });
      if (res?.status) {
        // Modify status to be properly cased - i.e. changed DECLINED to Declined
        const casedResult =
          res?.data.data.status.charAt(0) +
          res?.data.data.status.slice(1).toLowerCase();
        setCreditResult(casedResult);
      }
      if (res?.data.data.id) {
        setConfirmedApp(true);
        setLoanId(res.data.data.id);
        await saveLoanInfo(res.data.data);
      }
      if (res?.data?.data?.decisionExplanation?.reasons[0]?.description) {
        setCreditMessage(
          res?.data?.data?.decisionExplanation?.reasons[0]?.description
        );
      }
      if (res?.data?.data[0]?.description.length) {
        return (
          setShowError(true),
          setErrorMessage(`${res?.data.data[0].description}.`),
          setTimeout(function () {
            setShowError(false);
            setErrorMessage(``);
          }, 10000)
        );
      }
    } catch (err) {
      console.error(err);
      return (
        setShowError(true),
        setErrorMessage(`Failed to submit application. Please try again.`),
        setTimeout(function () {
          setShowError(false);
          setErrorMessage(``);
        }, 10000)
      );
    } finally {
      setLoading(false);
    }
  };

  const saveLoanInfo = async (loanData) => {
    try {
      const loanInfo = {
        project_id: customer?.projectID,
        loan_id: loanData.id,
        offer_id: formState.offerId,
        decision: loanData.status,
        first_name: formState.firstName,
        last_name: formState.lastName,
        email: formState.email,
        phone_number: formState.primaryPhoneNumber_value,
        co_first_name: formState.coapplicant_firstName,
        co_last_name: formState.coapplicant_lastName,
        co_email: formState.coapplicant_email,
        co_phone_number: formState.coapplicant_primaryPhoneNumber_value,
      };
      await GoodLeapApi.addGoodleapApp({ loanInfo: loanInfo });
    } catch (err) {
      console.error(err);
    }
  };

  const getGoodLeapAppInfo = async (id) => {
    try {
      const res = await GoodLeapApi.getGoodleapAppInfo({ loanId: id });
      if (res?.decision) {
        const casedResult =
          res?.decision.charAt(0) + res?.decision.slice(1).toLowerCase();
        setCreditResult(casedResult);
        setValuesFromGoodLeapApp(res.data.data);
      }
      if (res?.data?.data[0]?.description.length) {
        return (
          setShowError(true),
          setErrorMessage(`${res?.data.data[0].description}.`),
          setTimeout(function () {
            setShowError(false);
            setErrorMessage(``);
          }, 10000)
        );
      }
    } catch (err) {
      console.error(err);
    }
  };

  const setValuesFromGoodLeapApp = (response) => {
    const valuesToSet = [
      { key: "firstName", value: response.appFirstName },
      { key: "lastName", value: response.appLastName },
      { key: "email", value: response.appEmail },
      { key: "primaryPhoneNumber_value", value: response.appPhone },
    ];
    valuesToSet.forEach((item) => {
      handleInputChange(item.key, item.value);
    });
  };

  const emailLoanDocs = async () => {
    try {
      await GoodLeapApi.sendLoanDocs({ loanId: loanId });
    } catch (err) {
      console.error(err);
      return (
        setShowError(true),
        setErrorMessage(`Failed to send loan documents. Please try again.`),
        setTimeout(function () {
          setShowError(false);
          setErrorMessage(``);
        }, 10000)
      );
    }
  };

  function formatPhoneNumber(value) {
    // if input value is falsy eg if the user deletes the input, then just return
    if (!value) return value;

    // clean the input for any non-digit values.
    const phoneNumber = value.replace(/[^\d]/g, "");

    // phoneNumberLength is used to know when to apply our formatting for the phone number
    const phoneNumberLength = phoneNumber.length;

    // we need to return the value with no formatting if its less then four digits
    // this is to avoid weird behavior that occurs if you  format the area code to early
    if (phoneNumberLength < 4) return phoneNumber;

    // if phoneNumberLength is greater than 4 and less the 7 we start to return
    // the formatted number
    if (phoneNumberLength < 7) {
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    }

    // finally, if the phoneNumberLength is greater then seven, we add the last
    // bit of formatting and return it.
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
      3,
      6
    )}-${phoneNumber.slice(6, 10)}`;
  }

  const loanName = loanA.isPpa
    ? `${loanA.loanName} ${loanA.loanTerm} YR $${loanA.ppaRate.toFixed(
        2
      )} KW/h ${(loanA.ppaEscalator * 100).toFixed(2)}% Annual Escalation Rate`
    : `Goodleap ${loanA?.loanTerm} YR ${loanA?.loanInterest}% APR`;

  const mappedApplications = goodLeapApplications.map((app, i) => {
    return (
      <tr key={i}>
        <td className="qualyText bold" scope="row">
          {app.appFirstName} {app.appLastName}
          {app.appCoFirstName
            ? ` & ${app.appCoFirstName} ${app.appCoLastName}`
            : null}
        </td>
        <td className="qualyText bold" scope="row">
          {moment(app.time).format("MM/DD/YYYY")}
        </td>
        <td
          className={
            app.shareId
              ? "qualyText bold docs"
              : app.decision === "Approved"
              ? "qualyText bold approved"
              : app.decision === "Declined" || app.decision === "Blocked"
              ? "qualyText bold declined"
              : app.decision === "ApprovedWithStipulations"
              ? "qualyText bold condition"
              : "qualyText bold"
          }
          scope="row"
        >
          {app.shareId
            ? "Docs Sent"
            : app.decision === "ApprovedWithStipulations"
            ? "Conditionally Approved"
            : app.decision}
        </td>
        <td
          className="qualyText blue"
          scope="row"
          onClick={() => {
            getGoodLeapAppInfo(app.loanId);
            setLoanId(app.loanId);
            setConfirmedApp(true);
          }}
        >
          View
        </td>
      </tr>
    );
  });

  return (
    <>
      <div className="container">
        <div className="custContainer">
          <div className="row justify-content-between">
            <div className="col">
              <img className="img logo" src={GoodLeapLogo}></img>
              {loanA && !viewApps && <h4>{loanName}</h4>}
            </div>
            <div className="col" align="end">
              <div className="qualyText header back">
                <Button
                  variant="outlined"
                  color="default"
                  onClick={() => {
                    setGoodLeap(false);
                    setViewApps(false);
                  }}
                >
                  Back
                </Button>
              </div>
            </div>
          </div>
          {confirmedApp ? (
            <>
              <div className="row">
                <div className="col">
                  <div className="qualyText header">Credit Application</div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="qualyText">
                    Please view your application details and status below.
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="qualyText info">First Name</div>
                  <div className="qualyText info bold moz">
                    {formState?.firstName}
                  </div>
                </div>
                <div className="col">
                  <div className="qualyText info">Last Name</div>
                  <div className="qualyText info bold moz">
                    {formState?.lastName}
                  </div>
                </div>
                <div className="col">
                  <div className="qualyText info">Email Address</div>
                  <div className="qualyText info bold moz">
                    {formState?.email}
                  </div>
                </div>
                <div className="col">
                  <div className="qualyText info">Mobile Phone</div>
                  <div className="qualyText info bold moz">
                    {formState?.primaryPhoneNumber_value.replace(
                      /(\d{3})(\d{3})(\d{4})/,
                      "($1) $2-$3"
                    )}
                  </div>
                </div>
              </div>
              {formState?.coapplicant_firstName ? (
                <>
                  <div className="row">
                    <div className="col">
                      <div className="qualyText info moz">
                        Co-Applicant First Name
                      </div>
                      <div className="qualyText info bold">
                        {formState?.coapplicant_firstName}
                      </div>
                    </div>
                    <div className="col">
                      <div className="qualyText info moz">
                        Co-Applicant Last Name
                      </div>
                      <div className="qualyText info bold">
                        {formState?.coapplicant_lastName}
                      </div>
                    </div>
                    <div className="col">
                      <div className="qualyText info moz">
                        Co-Applicant Email Address
                      </div>
                      <div className="qualyText info bold">
                        {formState?.coapplicant_email}
                      </div>
                    </div>
                    <div className="col">
                      <div className="qualyText info moz">
                        Co-Applicant Mobile Phone
                      </div>
                      <div className="qualyText info bold">
                        {formState?.coapplicant_primaryPhoneNumber_value?.replace(
                          /(\d{3})(\d{3})(\d{4})/,
                          "($1) $2-$3"
                        )}
                      </div>
                    </div>
                  </div>
                </>
              ) : null}
              {showError || confirmEmail ? (
                <>
                  <div className="row justify-content-center">
                    <div className="col" align="center">
                      <div
                        className={
                          confirmEmail ? "errorMessage green" : "errorMessage"
                        }
                      >
                        {errorMessage}
                      </div>
                    </div>
                  </div>
                </>
              ) : null}
              <div className="row">
                <div className="col">
                  <div className="qualyText credit">Credit Decision</div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <button
                    className={
                      creditResult === "Approved"
                        ? "custButton approved"
                        : creditResult === "Conditional" ||
                          creditResult === "Pending"
                        ? "custButton condition"
                        : creditResult === "Declined"
                        ? "custButton declined"
                        : "qualyText"
                    }
                  >
                    {creditResult === "Conditional"
                      ? "Conditionally Approved"
                      : creditResult}
                  </button>
                </div>
                {creditResult === "Declined" ||
                creditMessage.status === "Blocked" ? (
                  <>
                    <div className="col">
                      <button
                        className="custButton confirm credit"
                        onClick={() => {
                          setViewApps(false);
                          setConfirmedApp(false);
                          setCreditMessage({});
                          setCreditResult("Pending");
                        }}
                      >
                        {" "}
                        Create New Application
                      </button>
                    </div>
                  </>
                ) : creditResult === "Pending" ? (
                  <></>
                ) : (
                  <>
                    {loanId && (
                      <>
                        <div className="col-3">
                          <button
                            className="custButton cancel credit"
                            onClick={() => emailLoanDocs()}
                          >
                            Email Loan Docs
                          </button>
                        </div>
                      </>
                    )}
                  </>
                )}
              </div>
              <div>
                <div>
                  {creditResult === "Approved" ? (
                    <>
                      <div className="row">
                        <div className="savingsText modals fin">
                          Loan Amount:{" "}
                        </div>
                      </div>
                      <div className="row">
                        <div className="qualyText decisions">
                          {loanAmount.toLocaleString(undefined, {
                            style: "currency",
                            currency: "USD",
                          })}
                        </div>
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </>
          ) : viewApps ? (
            <>
              <div className="row">
                <h3 className="menuFont qualy">Applications</h3>
              </div>
              <table className="table table-striped table-borderless">
                <thead>
                  <tr className="table-borderless">
                    <th className="qualyText" scope="col">
                      Applicant Name
                    </th>
                    <th className="qualyText" scope="col">
                      Submitted
                    </th>
                    <th className="qualyText" scope="col">
                      Status
                    </th>
                    <th className="qualyText" scope="col"></th>
                  </tr>
                </thead>
                <tbody>{mappedApplications}</tbody>
              </table>
              <div className="row">
                <div className="col-5">
                  <button
                    className="custButton confirm"
                    onClick={() => setViewApps(false)}
                  >
                    Create New Application
                  </button>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="row">
                <div className="col">
                  <div className="qualyText header">Pre-qualification</div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="qualyText">
                    Please provide a valid email address you can access and a
                    mobile phone number to receive instant notifications about
                    your project and keep it running smoothly.
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm">
                  <div className="qualyText holders">First Name</div>
                  <input
                    className="custInput qualy"
                    placeholder="Legal First Name"
                    value={formState.firstName}
                    onChange={(e) =>
                      handleInputChange("firstName", e.target.value)
                    }
                  ></input>
                </div>
                <div className="col">
                  <div>
                    <div className="qualyText holders">Last Name</div>
                  </div>
                  <input
                    className="custInput qualy"
                    placeholder="Legal Last Name"
                    value={formState.lastName}
                    onChange={(e) =>
                      handleInputChange("lastName", e.target.value)
                    }
                  ></input>
                </div>
              </div>
              <div className="row">
                <div className="col-sm">
                  <div>
                    <div className="qualyText holders">Email Address</div>
                  </div>
                  <input
                    className="custInput qualy"
                    placeholder="email@email.com"
                    value={formState.email}
                    onChange={(e) => handleInputChange("email", e.target.value)}
                  ></input>
                </div>
                <div className="col">
                  <div>
                    <div className="qualyText holders">Mobile Phone</div>
                  </div>
                  <input
                    className="custInput qualy"
                    type="tel"
                    placeholder="(000) 000-0000"
                    value={formState.primaryPhoneNumber_value}
                    onChange={(e) =>
                      handleInputChange(
                        "primaryPhoneNumber_value",
                        formatPhoneNumber(e.target.value)
                      )
                    }
                  ></input>
                </div>
              </div>
              <div className="row">
                <div className="col-sm">
                  <div>
                    <div className="qualyText holders">
                      Personal Income (Annual)
                    </div>
                  </div>
                  <NumberFormat
                    className="custInput qualy"
                    thousandSeparator={true}
                    prefix="$"
                    placeholder="$XX,XXX"
                    type="text"
                    onValueChange={(values) =>
                      handleInputChange("annualIncome_value", values.floatValue)
                    }
                  ></NumberFormat>
                </div>
                <div className="col">
                  <div className="qualyText holders">
                    Other Household Income
                  </div>
                  <NumberFormat
                    className="custInput qualy"
                    thousandSeparator={true}
                    prefix="$"
                    placeholder="$XX,XXX"
                    type="text"
                    onChange={(e) => setSecondaryIncome(e.target.value)}
                  ></NumberFormat>
                  <div className="qualyText disc">{otherInc}</div>
                </div>
                <div className="col">
                  <div>
                    <div className="qualyText holders">
                      Last 4 of Social Security
                    </div>
                  </div>
                  <input
                    className="custInput qualy"
                    placeholder="0000"
                    type="number"
                    maxLength={4}
                    value={formState.ssn}
                    onChange={(e) =>
                      handleInputChange("ssn", e.target.value.slice(0, 4))
                    }
                  ></input>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div>
                    <div className="qualyText holders">Birthday Month</div>
                  </div>
                  <select
                    className="custInput qualy"
                    onChange={(e) => setBirthMonth(e.target.value)}
                  >
                    <option style={{ display: "none" }}>Month</option>
                    {mappedMonths}
                  </select>
                </div>
                <div className="col">
                  <div>
                    <div className="qualyText holders">Birthday Day</div>
                  </div>
                  <select
                    className="custInput qualy"
                    onChange={(e) => setBirthDay(e.target.value)}
                  >
                    <option style={{ display: "none" }}>Day</option>
                    {mappedDays}
                  </select>
                </div>
                <div className="col">
                  <div>
                    <div className="qualyText holders">Birthday Year</div>
                  </div>
                  <select
                    className="custInput qualy"
                    onChange={(e) => setBirthYear(e.target.value)}
                  >
                    <option style={{ display: "none" }}>Year</option>
                    {mappedYears}
                  </select>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="qualyText">
                    Tell us where this project will be located.
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-4">
                  <div>
                    <div className="qualyText holders">Street Address</div>
                  </div>
                  <input
                    className="custInput qualy"
                    placeholder="Street"
                    value={formState.street}
                    onChange={(e) =>
                      handleInputChange("street", e.target.value)
                    }
                  ></input>
                </div>
                <div className="col-sm-4">
                  <div>
                    <div className="qualyText holders">City</div>
                  </div>
                  <input
                    className="custInput qualy"
                    placeholder="City"
                    value={formState.city}
                    onChange={(e) => handleInputChange("city", e.target.value)}
                  ></input>
                </div>
                <div className="col-sm-2 col">
                  <div>
                    <div className="qualyText holders">State</div>
                    <select
                      className="custInput qualy moz"
                      value={formState.state}
                      onChange={(e) =>
                        handleInputChange("state", e.target.value)
                      }
                    >
                      <option style={{ display: "none" }}> {stateA}</option>
                      {mappedStates}
                    </select>
                  </div>
                </div>
                <div className="col-sm-2 col">
                  <div>
                    <div className="qualyText holders">Zip Code</div>
                  </div>
                  <input
                    className="custInput qualy"
                    placeholder="00000"
                    label={zip}
                    value={formState.zip}
                    onChange={(e) => handleInputChange("zip", e.target.value)}
                  ></input>
                </div>
              </div>
              <div
                className="row"
                onClick={(e) => {
                  setCoApply(!coApply);
                }}
              >
                <div className="col-sm-1 col-2">
                  <div className={coApply ? "checkBox checked" : "checkBox"}>
                    <img src={checkmark}></img>
                  </div>
                </div>
                <div className="col">
                  <div className="qualyText check">Add Co-Applicant</div>
                </div>
              </div>

              {coApply ? (
                <>
                  <div className="row">
                    <div className="col-sm">
                      <div className="qualyText holders">
                        Co-Applicant First Name
                      </div>
                      <input
                        className="custInput qualy"
                        placeholder="Legal First Name"
                        value={formState.coapplicant_firstName}
                        onChange={(e) =>
                          handleInputChange(
                            "coapplicant_firstName",
                            e.target.value
                          )
                        }
                      ></input>
                    </div>
                    <div className="col">
                      <div>
                        <div className="qualyText holders">
                          Co-Applicant Last Name
                        </div>
                      </div>
                      <input
                        className="custInput qualy"
                        placeholder="Legal Last Name"
                        value={formState.coapplicant_lastName}
                        onChange={(e) =>
                          handleInputChange(
                            "coapplicant_lastName",
                            e.target.value
                          )
                        }
                      ></input>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm">
                      <div>
                        <div className="qualyText holders">
                          Co-Applicant Email Address
                        </div>
                      </div>
                      <input
                        className="custInput qualy"
                        placeholder="email@email.com"
                        value={formState.coapplicant_email}
                        onChange={(e) =>
                          handleInputChange("coapplicant_email", e.target.value)
                        }
                      ></input>
                    </div>
                    <div className="col">
                      <div>
                        <div className="qualyText holders">
                          Co-Applicant Mobile Phone
                        </div>
                      </div>
                      <input
                        className="custInput qualy"
                        type="tel"
                        placeholder="(000) 000-0000"
                        value={formState.coapplicant_primaryPhoneNumber_value}
                        onChange={(e) =>
                          handleInputChange(
                            "coapplicant_primaryPhoneNumber_value",
                            formatPhoneNumber(e.target.value)
                          )
                        }
                      ></input>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm">
                      <div>
                        <div className="qualyText holders">
                          Co-Applicant Personal Income (Annual)
                        </div>
                      </div>
                      <NumberFormat
                        className="custInput qualy"
                        thousandSeparator={true}
                        prefix="$"
                        placeholder="$XX,XXX"
                        type="text"
                        onValueChange={(values) =>
                          handleInputChange(
                            "coapplicant_annualIncome_value",
                            values.floatValue
                          )
                        }
                      ></NumberFormat>
                    </div>
                    <div className="col">
                      <div>
                        <div className="qualyText holders">
                          Last 4 of Co-Applicant's Social Security
                        </div>
                      </div>
                      <input
                        className="custInput qualy"
                        placeholder="0000"
                        type="number"
                        maxLength={4}
                        value={formState.coapplicant_ssn}
                        onChange={(e) =>
                          handleInputChange(
                            "coapplicant_ssn",
                            e.target.value.slice(0, 4)
                          )
                        }
                      ></input>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <div>
                        <div className="qualyText holders">
                          Co-Applicant Birthday Month
                        </div>
                      </div>
                      <select
                        className="custInput qualy moz"
                        onChange={(e) => setCoBirthMonth(e.target.value)}
                      >
                        <option style={{ display: "none" }}>Month</option>
                        {mappedMonths}
                      </select>
                    </div>
                    <div className="col">
                      <div>
                        <div className="qualyText holders">
                          Co-Applicant Birthday Day
                        </div>
                      </div>
                      <select
                        className="custInput qualy"
                        onChange={(e) => setCoBirthDay(e.target.value)}
                      >
                        <option style={{ display: "none" }}>Day</option>
                        {mappedCoDays}
                      </select>
                    </div>
                    <div className="col">
                      <div>
                        <div className="qualyText holders">
                          Co-Applicant Birthday Year
                        </div>
                      </div>
                      <select
                        className="custInput qualy"
                        onChange={(e) => setCoBirthYear(e.target.value)}
                      >
                        <option style={{ display: "none" }}>Year</option>
                        {mappedYears}
                      </select>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="row">
                    <div className="col">
                      <div className="qualyText disco">{coApp}</div>
                    </div>
                  </div>
                </>
              )}
              <div className="row">
                <div className="col">
                  <div className="qualyText pad">{pad.slice(23)}</div>
                </div>
              </div>
              <div>
                <CheckboxForm
                  handleInputChange={handleInputChange}
                  disclosures={disclosures}
                  setAllChecked={setAllChecked}
                  signature={formState.applicantSignature}
                />
              </div>
              {showError ? (
                <>
                  <div className="row justify-content-center">
                    <div className="col" align="center">
                      <div className="errorMessage">{errorMessage}</div>
                    </div>
                  </div>
                </>
              ) : null}
              <div className="row justify-content-center">
                <div className="col">
                  <button
                    className={
                      allChecked
                        ? "qualyButton confirm"
                        : "qualyButton disabled"
                    }
                    disabled={!allChecked}
                    onClick={
                      loading
                        ? () => null
                        : () => {
                            createApplication();
                          }
                    }
                  >
                    {loading ? (
                      <CircularProgress size={40} color="inherit" />
                    ) : (
                      "Submit"
                    )}
                  </button>
                </div>
              </div>
              <div className="row justify-content-center">
                <div className="col">
                  <div className="qualyText bottom">
                    Submitting this pre-qualification will{" "}
                    <span>not affect</span> your credit score.
                  </div>
                </div>
              </div>
              <div className="row justify-content-center">
                <div className="col">
                  <div className="qualyText bottom bold">
                    YOUR INFORMATION IS SECURED BY{" "}
                    <img className="img" src={ssl}></img> SSL{" "}
                    <img className="img" src={encryption}></img> 128-BIT
                    ENCRYPTION
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default GoodLeapQualify;
